import React from 'react'

const Cp_pointer = () => {
    return (
        <div className='container'>
            <h1>Pointers in C++</h1>
            <p>Pointer is a variable in C++ that holds the address of another variable. They have data type just
                 like variables, for example an integer type pointer can hold the address of an integer variable 
                 and an character type pointer can hold the address of char variable.</p>
            <h4>Syntax of pointer</h4>
            <div className='output'>
            data_type *pointer_name;
            </div>
            <h3>How to declare a pointer?</h3>
            <div className='containers'>
           <code className='comment'> /* This pointer p can hold the address of an integer <br />
 * variable, here p is a pointer and var is just a <br />
 * simple integer variable <br />
 */</code> <br />
<code className='keywords'> int </code>*p, var
            </div>
            <h3>Assignment</h3>
            <p><strong>Assignment</strong><br/>
As I mentioned above, an integer type pointer can hold the address of another int variable. Here we have an 
integer variable var and pointer p holds the address of var. To assign the address of variable to pointer we
 use <strong>ampersand symbol</strong> (&amp;).</p>
 <div className='containers'>
 <code className='comment'>/* This is how you assign the address of another variable <br />
 * to the pointer <br />
 */ <br /></code> 
p = &var;
 </div>
 <h3>How to use it?</h3>
 <div className='containers'>
 <code class='comment'> // This will print the address of variable var <br/>
cout&lt;&lt;&var;     <br/>
 <br/>
/* This will also print the address of variable <br/>
 * var because the pointer p holds the address of var <br/>
 */</code> <br/>
cout&lt;&lt;p;     <br/>
<code class="comment"> <br/>
/* This will print the value of var, This is  <br/>
 * important, this is how we access the value of <br/>
 * variable through pointer <br/>
*/</code> <br/>
cout&lt;&lt;*p;  <br/>
 </div>
 <h3>Example of Pointer</h3>
 <pre class="containers"><span class="comment">#include</span><span class="plain"> </span><span class="str">&lt;iostream&gt;</span><span class="plain"> <br/>
</span><span class="keywords">using</span><span class="plain"> </span><span class="keywords">namespace</span><span class="plain"> std</span><span class="pun">;</span><span class="plain"> <br/>
</span><span class="keywords">int</span><span class="plain"> main</span><span class="pun">()&#123;</span><span class="plain"> <br/>
   </span><span class="comment">//Pointer declaration</span><span class="plain"> <br/>
   </span><span class="keywords">int</span><span class="plain"> </span><span class="pun">*</span><span class="plain">p</span><span class="pun">,</span><span class="plain"> </span><span class="keywords">var</span><span class="pun">=</span><span class="lit">101</span><span class="pun">;</span><span class="plain"> <br/>
  <br/>
   </span><span class="comment">//Assignment</span><span class="plain"> <br/>
   p </span><span class="pun">=</span><span class="plain"> </span><span class="pun">&amp;</span><span class="keywords">var</span><span class="pun">;</span><span class="plain"> <br/>
 <br/>
   cout</span><span class="pun">&lt;&lt;</span><span class="str">"Address of var: "</span><span class="pun">&lt;&lt;&amp;</span><span class="keywords">var</span><span class="pun">&lt;&lt;</span><span class="plain">endl</span><span class="pun">;</span><span class="plain"> <br/>
   cout</span><span class="pun">&lt;&lt;</span><span class="str">"Address of var: "</span><span class="pun">&lt;&lt;</span><span class="plain">p</span><span class="pun">&lt;&lt;</span><span class="plain">endl</span><span class="pun">;</span><span class="plain"> <br/>
   cout</span><span class="pun">&lt;&lt;</span><span class="str">"Address of p: "</span><span class="pun">&lt;&lt;&amp;</span><span class="plain">p</span><span class="pun">&lt;&lt;</span><span class="plain">endl</span><span class="pun">;</span><span class="plain"> <br/>
   cout</span><span class="pun">&lt;&lt;</span><span class="str">"Value of var: "</span><span class="pun">&lt;&lt;*</span><span class="plain">p</span><span class="pun">;</span><span class="plain"> <br/>
   </span><span class="keywords">return</span><span class="plain"> </span><span class="lit">0</span><span class="pun">;</span><span class="plain"> <br/>
</span><span class="pun">&#125;</span></pre> <br/>
<h2>Pointer and arrays</h2>
<p>While handling arrays with pointers you need to take care few things. First and very important point to note
     regarding arrays is that the array name alone represents the base address of array so while assigning the 
     address of array to pointer don’t use ampersand sign(&amp;). Do it like this:<br/>
<strong>Correct:</strong> Because arr represent the address of array.</p>
<div className='output'>
p = arr; <br />
</div>
<strong>Incorrect:</strong>
<div className='output'>
p = &amp;arr;
</div>

        </div>
    )
}

export default Cp_pointer
